if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      
      // On mobile, set up intersection observer for video autoplay
      if (!this.mql.matches) {
        this.setupVideoAutoplay();
      }
      
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      // Get the actually visible slide (not the event's currentElement which is wrong)
      const actualActiveSlide = this.elements.viewer.querySelector('.slideshow__slide.is-active');
      
      if (actualActiveSlide && this.elements.thumbnails) {
        const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${actualActiveSlide.dataset.mediaId}"]`);
        this.setActiveThumbnail(thumbnail);
      }
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      if(!activeMedia) return;
      console.log("before media thiu");
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);

      //{% comment %} *** Start of VertoSpin Code *** {% endcomment %}
      if (activeMedia.getAttribute('data-verto-contant') === 'true') {
        setVertoSpinSize();
      }
      //{% comment %} *** End of VertoSpin Code *** {% endcomment %}
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    // Set up Intersection Observer for mobile video autoplay
    setupVideoAutoplay() {
      const slides = this.elements.viewer.querySelectorAll('.slideshow__slide');
      
      // Create intersection observer with high threshold for visibility
      this.videoObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
            // Slide is more than 50% visible - check for video and play
            this.checkAndPlayVideo(entry.target);
          } else {
            // Slide is not visible - pause any videos in it
            this.pauseVideoInSlide(entry.target);
          }
        });
      }, {
        root: this.elements.viewer,
        threshold: [0.5, 0.8] // Trigger when 50% or 80% visible
      });
      
      // Observe all slides
      slides.forEach(slide => {
        this.videoObserver.observe(slide);
      });
    }

    // Check if slide has video and play it
    checkAndPlayVideo(slide) {
      // Look for inline video content first
      const mobileVideoContent = slide.querySelector('.mobile-video-content');
      if (mobileVideoContent) {
        const video = mobileVideoContent.querySelector('video');
        if (video) {
          this.playVideo(video);
          return;
        }
      }
      
      // Look for deferred media video
      const deferredMedia = slide.querySelector('.deferred-media');
      if (deferredMedia) {
        const template = deferredMedia.querySelector('template');
        if (template && template.innerHTML.includes('<video')) {
          deferredMedia.loadContent(false);
          setTimeout(() => {
            const video = deferredMedia.querySelector('video');
            if (video) {
              this.playVideo(video);
            }
          }, 500);
        }
      }
    }

    // Play video with proper settings
    playVideo(video) {
      window.pauseAllMedia(); // Stop other media first
      
      // Remove video-active class from all deferred-media elements
      this.elements.viewer.querySelectorAll('.deferred-media').forEach(media => {
        media.classList.remove('video-active');
      });
      
      // Add video-active class to the current video's deferred-media container
      const deferredMedia = video.closest('.deferred-media');
      if (deferredMedia) {
        deferredMedia.classList.add('video-active');
      }
      
      video.muted = true;
      video.loop = true;
      video.currentTime = 0; // Start from beginning
      
      video.play().catch(() => {
        // Auto-play failed, user interaction required
      });
    }

    // Pause video in slide when it's not visible
    pauseVideoInSlide(slide) {
      const videos = slide.querySelectorAll('video');
      videos.forEach(video => {
        if (!video.paused) {
          video.pause();
          
          // Remove video-active class when pausing
          const deferredMedia = video.closest('.deferred-media');
          if (deferredMedia) {
            deferredMedia.classList.remove('video-active');
          }
        }
      });
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
